import { coreTranslations } from 'translations';

function _rootMenu() {
    return {
        i18n: coreTranslations.ng_core_dashboard,
        linkTitle: 'Control Center',
        icon: 'onsolve-home-icon',
        routeTo: '/',
        autoFocus: true,
        isEnabled: true,
        isRenderable: true
    };
}

const DashboardMenuItems = _rootMenu;

export default DashboardMenuItems;
